export default "__VITE_ASSET__mM_43U1k__"